"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _q = _interopRequireDefault(require("q"));

var _default = function _default(name) {
  var earlyMetaRequest = window.quickFetch && window.quickFetch.getRequestStateByName(name);
  if (!earlyMetaRequest) return null;
  return new _q.default.Promise(function (resolve, reject) {
    earlyMetaRequest.whenFinished(function (result) {
      resolve(result);
      window.quickFetch.removeEarlyRequest(name);
    });
    earlyMetaRequest.onError(function (xhr, errorCode) {
      reject(xhr, errorCode);
      window.quickFetch.removeEarlyRequest(name);
    });
  });
};

exports.default = _default;
module.exports = exports.default;